export const groupGdsSelectedServices = (serviceGroup) => {
    const servicesMap = new Map();
    serviceGroup.selectedServices.forEach(service => {
        var _a, _b, _c, _d;
        const serviceRfics = service.service.rfics;
        servicesMap.set(serviceRfics, {
            service: (_b = (_a = servicesMap.get(serviceRfics)) === null || _a === void 0 ? void 0 : _a.service) !== null && _b !== void 0 ? _b : service.service,
            count: ((_d = (_c = servicesMap.get(serviceRfics)) === null || _c === void 0 ? void 0 : _c.count) !== null && _d !== void 0 ? _d : 0) + service.count
        });
    });
    const selectedServices = [];
    servicesMap.forEach(services => {
        selectedServices.push(services);
    });
    return selectedServices;
};
